<template>
  <div class="w-scroll">
    <div v-if="!rows.length" class="w-empty"><i class="fas fa-trophy"></i>{{ stats.topForests ? 'No forests yet' : 'Loading…' }}</div>
    <div v-for="(f, i) in rows" :key="f.id" class="tf w-row-in" :style="{ animationDelay: (i * 0.06) + 's' }" role="link" tabindex="0" :title="'Open ' + f.name" @click="open(f)" @keyup.enter="open(f)">
      <span class="tf-rank" :class="'r' + (i + 1)">
        <i v-if="i < 3" class="fas fa-medal"></i><template v-else>{{ i + 1 }}</template>
      </span>
      <span class="tf-img" :style="f.image ? { backgroundImage: `url('${f.image}')` } : {}"><i v-if="!f.image" class="fas fa-tree"></i></span>
      <div class="tf-main">
        <div class="tf-line">
          <span class="tf-name" :title="f.name">{{ f.name }}</span>
          <span class="tf-co2"><b>{{ fmt(f.co2, 1) }}</b> t</span>
        </div>
        <div class="w-bar"><span :style="{ '--w': f.share + '%', background: 'linear-gradient(90deg, var(--accent-green), var(--co2-accent))', animationDelay: (0.25 + i * 0.06) + 's' }"></span></div>
        <div class="tf-meta">{{ f.country || '—' }} · {{ fmt(f.trees) }} trees · {{ fmt(f.ha, 2) }} ha</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fmt, imageUrl } from '../theme';

export default {
  name: 'TopForests',
  props: { stats: { type: Object, required: true } },
  computed: {
    rows() {
      const rows = (this.stats.topForests || []).map((f) => ({ id: f.id, name: f.name, country: f.country, trees: Number(f.trees) || 0, ha: Number(f.areaHa) || 0, co2: Number(f.co2) || 0, image: imageUrl(f.image) }));
      const max = Math.max(1, ...rows.map((r) => r.co2));
      return rows.map((r) => ({ ...r, share: Math.max(3, (r.co2 / max) * 100) }));
    }
  },
  methods: {
    fmt,
    open(f) { if (f.id) this.$router.push(`/areas/${f.id}`); }
  }
};
</script>

<style scoped lang="scss">
@import '../widgets.scss';

.tf {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 4px;
  border-radius: 12px;
  transition: background 0.2s, transform 0.2s;

  cursor: pointer;
  &:hover { background: var(--bg-secondary); transform: translateX(2px); }
  &:focus-visible { outline: 2px solid rgba(var(--accent-green-rgb), 0.6); }
}

.tf-rank {
  width: 26px;
  flex: 0 0 26px;
  text-align: center;
  font-weight: 800;
  color: var(--text-muted);
  font-size: 0.85rem;

  &.r1 { color: #e0a52e; font-size: 1.15rem; }
  &.r2 { color: #9aa7b0; font-size: 1.05rem; }
  &.r3 { color: #c27c4a; font-size: 1rem; }
}

.tf-img {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  border-radius: 12px;
  background: rgba(var(--accent-green-rgb), 0.12) center / cover no-repeat;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-green);
  box-shadow: var(--shadow-sm);
}

.tf-main { flex: 1 1 auto; min-width: 0; }
.tf-line { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 5px; }
.tf-name { font-weight: 700; color: var(--text-heading); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tf-co2 { font-size: 0.8rem; color: var(--text-muted); white-space: nowrap; b { color: var(--text-heading); } }
.tf-meta { margin-top: 4px; font-size: 0.72rem; color: var(--text-muted); }
</style>
